// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import FlowEditorController from "./flow_editor_controller"
application.register("flow-editor", FlowEditorController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import WidgetController from "./widget_controller"
application.register("widget", WidgetController)
